import {
  BellOutlined,
  BulbOutlined,
  CarryOutOutlined,
  GlobalOutlined,
  LogoutOutlined,
  MenuOutlined,
  ToolOutlined,
} from '@ant-design/icons'
import { Dropdown, Menu } from 'antd'
import axios from 'axios'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import {
  Role,
  useGetFeedsRecommendedQuery,
  useGetViewerQuery,
  useViewerAnnouncementUpdateMutation,
  useViewerLanguageUpdateMutation,
  useViewerOnboardingUpdateMutation,
} from '@/generated/graphql'
import { BannerImageModal } from '@/modules/recommend/banner/banner-images/banner-images-modal.component'
import { routes } from '@/routes'

import s from './user-menu.module.less'

export const UserMenu = () => {
  const { i18n, t } = useTranslation()
  const history = useHistory()
  const { data } = useGetViewerQuery()
  const { data: recommend } = useGetFeedsRecommendedQuery()
  const me = data!.viewer
  const roles = data!.viewer.roles.map((role) => role.role)
  const banners = recommend?.recommend.banners.edges.map(({ node }) => node).reverse() ?? []

  const [updateLanguage] = useViewerLanguageUpdateMutation()
  const [updateOnboarding] = useViewerOnboardingUpdateMutation()
  const [updateAnnouncement] = useViewerAnnouncementUpdateMutation()

  const onChangeLanguage = () => {
    const language = me.language === 'zh' ? 'en' : 'zh'
    i18n.changeLanguage(language)
    updateLanguage({
      variables: {
        language,
      },
    })
  }

  const onboarding = roles?.includes(Role.SystemAdmin) && (
    <Menu.Item key='onboarding' icon={<ToolOutlined />}>
      <a onClick={() => updateOnboarding({ variables: { hasOnboarding: false } })}>{t('sidebar.onboarding')}</a>
    </Menu.Item>
  )

  const manageBanner = roles?.includes(Role.SystemAdmin) && (
    <Menu.Item key='banner' icon={<CarryOutOutlined />}>
      <BannerImageModal images={banners}>
        <span className={s.manage}>{'管理 Banners'}</span>
      </BannerImageModal>
    </Menu.Item>
  )

  const announcement = roles?.includes(Role.SystemAdmin) && (
    <Menu.Item key='announcement' icon={<BulbOutlined />}>
      <a onClick={() => updateAnnouncement({ variables: { shouldBeAnnounced: true } })}>{t('sidebar.announcement')}</a>
    </Menu.Item>
  )

  const personalMenu = (
    <Menu>
      {manageBanner}
      {onboarding}
      {announcement}
      {roles?.includes(Role.SystemAdmin) && <Menu.Divider />}
      <Menu.Item
        key='notificationSetting'
        icon={<BellOutlined />}
        onClick={() => history.push(routes.notificationSettings.home())}
      >
        {t('notificationSetting.title')}
      </Menu.Item>
      <Menu.Item key='changeLanguage' icon={<GlobalOutlined />} onClick={onChangeLanguage}>
        {t('sidebar.changeLanguage')}
        <span>{me.language === 'zh' ? ' - English' : ' - 中文'}</span>
      </Menu.Item>
      <Menu.Item
        key='logout'
        icon={<LogoutOutlined />}
        onClick={async () => {
          await axios.get('/api/oauth/logout')
          window.location.href = `https://oauth.agoralab.co/oauth/logout?next=${encodeURIComponent(
            window.location.origin
          )}`
        }}
      >
        {t('sidebar.logout')}
      </Menu.Item>
    </Menu>
  )

  return (
    <div className={s.container}>
      <Dropdown
        arrow
        trigger={['click']}
        placement='topRight'
        overlay={personalMenu}
        getPopupContainer={(trigger) => trigger.parentElement || document.body}
      >
        <MenuOutlined />
      </Dropdown>
    </div>
  )
}
